import { useEffect } from 'react';
import useVerified from '../../../../lib/hooks/useVerified';
import BgStickyGradient from '../../../../ui/flow-components/bg-sticky-gradient';
import GradientText from '../../../../ui/flow-components/gradient-text';
import TextFade from '../../../../ui/flow-components/text-fade';
import OnboardingPersonalForm from './components/personal-form';

const OnboardingPersonalStep = () => {
  const { checkVerification } = useVerified();
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    checkVerification();
  }, [checkVerification]);

  return (
    <div className="min-h-screen relative w-screen bg-[#000f0f] overflow-hidden">
      <BgStickyGradient />

      <div className="flex flex-col lg:flex-row w-full min-h-screen relative z-10">
        {/* Welcome Section */}
        <div className="w-full lg:w-2/3 flex flex-col justify-center items-center p-6 lg:p-0 md:text-left text-center">
          {!isMobile && (
            <div className="p-4 lg:p-20 flex flex-col gap-4 lg:gap-8">
              <div className="flex text-[#B2B7B7] gap-2 items-center bg-white/5 rounded-full w-fit px-3 py-1 border border-white/5">
                <div>
                  <img src="/ratings.svg" alt="ratings" />
                </div>
                <p className="text-xs lg:text-sm">860+ positive Reviews</p>
              </div>
              <div className="flex flex-col gap-4">
                <p className="text-white text-2xl lg:text-4xl font-medium">
                  <TextFade>Willkommen zur award-winning</TextFade> <br /> <GradientText>Nr. 1 Design Flatrate</GradientText>{' '}
                  <TextFade>aus Deutschland.</TextFade>
                </p>
                <p className="text-[#B2B7B7] text-sm lg:text-base">In 2 Minuten eingerichtet und sofort startklar.</p>
              </div>
              <div className="mt-4 lg:mt-8">
                <img src="/awards.png" alt="awards" className="w-full h-full" style={{ filter: 'grayscale(1) brightness(0.70)' }} />
              </div>
            </div>
          )}
        </div>

        {/* Form Section */}
        <div className="w-full lg:w-1/3 p-4 lg:pr-16 pr-4 flex items-center">
          <div className="bg-white rounded-xl p-6 lg:p-8 w-full">
            <OnboardingPersonalForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingPersonalStep;
